import { useState, useEffect, ReactNode } from 'react';
import { Sport, SportThemeContext } from './sport-theme-context';

interface SportThemeProviderProps {
  children: ReactNode;
}

const SPORT_THEME_KEY = 'is-hub-sport-theme';

export function SportThemeProvider({ children }: SportThemeProviderProps) {
  const [currentSport, setCurrentSport] = useState<Sport>(() => {
    // Try to get saved sport from localStorage
    const savedSport = localStorage.getItem(SPORT_THEME_KEY);
    return (savedSport as Sport) || 'baseball';
  });

  // Update CSS variables when sport changes
  useEffect(() => {
    const root = document.documentElement;
    
    // Remove all sport classes from body
    document.body.classList.remove('sport-baseball', 'sport-football', 'sport-basketball');
    
    // Add current sport class
    document.body.classList.add(`sport-${currentSport}`);
    
    // Update CSS variable for sport accent color based on current sport
    switch (currentSport) {
      case 'baseball':
        root.style.setProperty('--sport-accent', '36 37% 55%'); // #C5A572
        break;
      case 'football':
        root.style.setProperty('--sport-accent', '123 39% 35%'); // #2E7D32
        break;
      case 'basketball':
        root.style.setProperty('--sport-accent', '30 100% 50%'); // #FF6F00
        break;
    }
    
    // Save to localStorage
    localStorage.setItem(SPORT_THEME_KEY, currentSport);
  }, [currentSport]);

  const setSport = (sport: Sport) => {
    setCurrentSport(sport);
  };

  return (
    <SportThemeContext.Provider value={{ currentSport, setSport }}>
      {children}
    </SportThemeContext.Provider>
  );
}